import type { FaireProductEntity } from "../../entity_types/product";

export const p_3j1eal625j: FaireProductEntity = {
  token: "p_3j1eal625j",
  type: "product",
  name: "NB7981 - Ribbed High Waist Leggings",
  brandToken: "b_44f349lcoo",
  brandName: "NIKIBIKI",
  imageUrl:
    "https://cdn.faire.com/fastly/6a55113a1c1c9e41e97f4232422381bbd4c009235d9965b462a91d2a22f7f9e8.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2ad8737690ad966b28dce22c730cccdabf15699a818164509799812e284bc066.jpeg",
    "https://cdn.faire.com/fastly/e6ce8d3fc877a9cba6b075e9dba336987dedbf0c2f022c3e9794cea59fc2959b.jpeg",
    "https://cdn.faire.com/fastly/68e6878f638972071568802fa0ee0454b46ba8ff7acbb009a73d95972d1ab517.jpeg",
    "https://cdn.faire.com/fastly/1a7086eefd4f78bafd1b085bd39a2ed2742da1635d2e7558b7fe925cffc73744.jpeg",
    "https://cdn.faire.com/fastly/8ce1f726af34618cd1ff71b86f6352256154b42deca3a382493a73919ef23504.jpeg",
  ],
  priceDollars: 14,
  description:
    "Size: One Size.\nRibbed knit leggings with an elasticized waist. High-waisted leggings sit high at the waist.\nFabric: 92% Nylon / 8% Spandex.\nMade in the USA\n\nAll of our leggings are knitted with elastic waistbands for a secure hold and a comfortable fit.\n\n\n",
  tags: [],
  msrpDollars: 42,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:49:01.747Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
